import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { JoliooRedemption } from "../../io/jolioo/voucher.types";
import { ButtonType } from "../../ui/button/button.type";
import { startNextVoucher } from "../../store/voucher/voucher.actions";
import { GetVoucherRedemption } from "../../store/voucher/voucher.selector";

/** Schritt 4: Ergebnis der Einlösung. */
@Component({
  selector: "app-voucher-done",
  templateUrl: "./voucher-done.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VoucherDoneComponent implements OnInit {
  public readonly ButtonType = ButtonType;

  public redemption$: Observable<JoliooRedemption | null>;

  constructor(
    private _store: Store,
    private _router: Router,
    private _route: ActivatedRoute,
  ) {
    this.redemption$ = this._store.select(GetVoucherRedemption);
  }

  ngOnInit(): void {
    // ⚠ Ohne Einlösung gibt es hier nichts zu melden.
    this.redemption$.pipe(take(1)).subscribe((redemption) => {
      if (!redemption) {
        this._router.navigate(["."], { relativeTo: this._route.parent });
      }
    });
  }

  /** Bleibt bei der Apotheke der letzten Einlösung. */
  public startOver(): void {
    this._store.dispatch(startNextVoucher());
    this._router.navigate(["."], { relativeTo: this._route.parent });
  }
}
